var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuoteReferenceNumber',{attrs:{"car-brand":_vm.carInfo.makeModel,"car-model":"","car-year":_vm.carInfo.modelYear,"hotline":"800 4742","whats-app":"97451047909","quote-od":_vm.convertOdQuoteToString,"quote-tpl":_vm.convertTplQuoteToString}})
}
var staticRenderFns = []

export { render, staticRenderFns }